/* ============================================================
   zzen-cta.js
   Mantiene el precio dentro del botón "Añadir al carrito"
   sincronizado con la variante seleccionada.

   POR QUÉ EXISTE
   --------------
   product-info.js llama a productForm.toggleSubmitButton() en cada
   cambio de variante, y esa función hace:

       this.submitButtonText.textContent = window.variantStrings.addToCart

   donde submitButtonText es el primer <span> del botón. Eso borra el
   precio y la etiqueta personalizada.

   Justo después, product-info.js publica PUB_SUB_EVENTS.variantChange
   con el HTML de la sección ya renderizado por Liquid. Nos suscribimos
   ahí y restauramos el contenido completo desde ese HTML: mismo patrón
   que usa Dawn en updateSourceFromDestination(). No hay que formatear
   moneda en JS ni vigilar el DOM.
   ============================================================ */

if (!customElements.get('zzen-cta')) {
  customElements.define(
    'zzen-cta',
    class ZzenCta extends HTMLElement {
      constructor() {
        super();
        this.unsubscribe = undefined;
      }

      connectedCallback() {
        // global.js define subscribe() y PUB_SUB_EVENTS. Si por lo que sea
        // no están (orden de carga alterado), el botón sigue funcionando:
        // solo pierde la actualización del precio al cambiar de variante.
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      get contentNode() {
        return this.querySelector('[data-zzen-cta-content]');
      }

      onVariantChange(event) {
        const html = event?.data?.html;
        if (!html) return;

        // Buscamos este mismo bloque en el HTML recién traído. Si no está,
        // el evento venía de otra sección: no tocamos nada.
        const source = html.getElementById(this.id);
        if (!source) return;

        const incoming = source.querySelector('[data-zzen-cta-content]');
        const current = this.contentNode;
        if (!incoming || !current) return;

        if (current.innerHTML !== incoming.innerHTML) {
          current.innerHTML = incoming.innerHTML;
        }
      }

      /* ------------------------------------------------------------
         API pública, para cuando montemos el selector de planes.

         El precio que muestra la suscripción no es el de la variante,
         sino el del selling plan. Cuando exista el selector, llamará a:

             document.querySelector('zzen-cta').setPrice({
               price: '68,90 €',
               compare: '89,70 €'
             });

         Pasar compare: null oculta el tachado.
         ------------------------------------------------------------ */
      setPrice({ price, compare } = {}) {
        const content = this.contentNode;
        if (!content) return;

        const priceNode = content.querySelector('.zzen-cta__price');
        const compareNode = content.querySelector('.zzen-cta__compare');
        const pricesWrap = content.querySelector('.zzen-cta__prices');

        if (priceNode && typeof price === 'string') {
          priceNode.textContent = price;
        }

        if (compareNode) {
          if (compare) {
            compareNode.textContent = compare;
            compareNode.hidden = false;
          } else {
            compareNode.hidden = true;
          }
        } else if (compare && pricesWrap) {
          const s = document.createElement('s');
          s.className = 'zzen-cta__compare';
          s.textContent = compare;
          pricesWrap.appendChild(s);
        }
      }

      /* Cambia la etiqueta en caliente (por ejemplo "Suscribirme" vs
         "Añadir al carrito" según el plan elegido). */
      setLabel(text) {
        const label = this.contentNode?.querySelector('.zzen-cta__label');
        if (label && typeof text === 'string') label.textContent = text;
      }
    }
  );
}
